import Pattern from './Pattern';

export default Pattern
export { Pattern as Base }
